import { useEffect } from "react";

import _ from "lodash";

import theme from "constants/theme-constants";

const useBodyBackground = (color: string) => {
    useEffect(() => {
        document.body.style.backgroundColor = _.get(theme, color, _.isEmpty(color) ? theme.lightblue : color);
        return () => {
            document.body.style.backgroundColor = theme.lightblue;
        };
    }, [color]);
};

export default useBodyBackground;
